import {ModuleComponent} from "../../js/module-component";

/**
 * Integraciones: enciende por turnos un hueco «+» de la rejilla con la siguiente conexión extra.
 */
export class ModTools extends ModuleComponent{

    ready(){
        super.ready();
        this.el = this.$root.get(0);
        if(!this.el) return;

        try{
            this.extras = JSON.parse(this.el.getAttribute("data-extras") || "[]");
        }catch(e){
            this.extras = [];
        }
        this.slots = Array.from(this.el.querySelectorAll(".js-mod-tools__slot"));
        this.cycle = parseInt(this.el.getAttribute("data-cycle"), 10) || 2200;
        this.tick = 0;

        if(!this.extras.length || !this.slots.length) return;
        if(window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

        this.visible = true;
        if("IntersectionObserver" in window){
            this.observer = new IntersectionObserver(entries => {
                this.visible = entries[0].isIntersecting;
                this.visible ? this.start() : this.stop();
            });
            this.observer.observe(this.el);
        }else{
            this.start();
        }
    }

    start(){
        if(this.timer) return;
        this.light();
        this.timer = setInterval(() => this.light(), this.cycle);
    }

    stop(){
        clearInterval(this.timer);
        this.timer = null;
    }

    light(){
        const s = "web-mod-tools";
        const slot = this.slots[this.tick % this.slots.length];
        const extra = this.extras[this.tick % this.extras.length];
        this.tick++;

        this.slots.forEach(el => {
            el.classList.remove("is-lit");
            const old = el.querySelector(`.${s}__lit`);
            if(old) old.remove();
        });

        const lit = document.createElement("span");
        lit.className = `${s}__lit`;
        const name = document.createElement("span");
        name.className = `${s}__lit-name`;
        name.textContent = extra.name;
        lit.appendChild(name);
        if(extra.category){
            const cat = document.createElement("span");
            cat.className = `${s}__lit-cat`;
            cat.textContent = extra.category;
            lit.appendChild(cat);
        }
        slot.appendChild(lit);
        slot.classList.add("is-lit");
    }

    destroy(){
        this.stop();
        if(this.observer) this.observer.disconnect();
        if(super.destroy) super.destroy();
    }
}
